export default __webpack_public_path__ + "static/media/illustration-uk.ef38b5a9.svg";